import React from 'react';
import { Box, Grid, Typography, Button } from '@mui/material';

interface Slide {
    header: string;
    subheader: string;
    body: string;
    image: {
        src: string;
        alt: string;
    };
}

const slide: Slide = {
    header: 'Coming Soon',
    subheader: 'Using the World of Crypto to Benefit the Real World',
    body: 'the first useful crypto instrument',
    image: {
        src: '/images/mrmoose.png',
        alt: 'Exempelbild',
    },
};

const Banner: React.FC = () => {
    return (
        <Box
            position="relative"
            p={{ xs: 4, md: 12 }}
            mx="auto"
            maxWidth={{ xs: '100%', md: 800, lg: 1200, xl: 1400 }}
            height="auto"
            overflow="hidden"
            display="flex"
            alignItems="center"
            sx={{ backgroundColor: '#121212', color: '#ffffff' }}
        >
            <Grid container spacing={6} alignItems="center" justifyContent="center" style={{ height: '100%' }}>
                <Grid item xs={12} md={8} textAlign={{ xs: 'left', md: 'left' }}>
                    <Typography
                        variant="h3"
                        gutterBottom
                        sx={{ color: '#1bd45a', marginBottom: 6 }}
                    >
                        {slide.header}
                    </Typography>
                    <Typography
                        variant="h3"
                        gutterBottom
                        sx={{ fontSize: { xs: '24px', md: '45px' } }}
                    >
                        {slide.subheader}
                    </Typography>
                    <Typography
                        variant="subtitle1"
                        gutterBottom
                        sx={{ fontSize: { xs: '16px', md: '18px' }, color: '#b0b0b0' }}
                    >
                        {slide.body}
                    </Typography>
                    <Button
                        href="mailto:feedback@moosebit.com"
                        variant="outlined"
                        sx={{
                            mt: 2,
                            paddingX: 3,
                            paddingY: 1,
                            borderColor: '#1bd45a',
                            color: '#1bd45a',
                            '&:hover': {
                                backgroundColor: '#1bd45a',
                                color: '#121212',
                            },
                        }}
                    >
                        Contact Us
                    </Button>
                </Grid>
                <Grid item xs={12} md={4} display="flex" justifyContent="center">
                    <Box
                        sx={{
                            overflow: 'hidden',
                            width: { xs: '80%', md: '100%' },
                            maxWidth: { xs: 300, md: 400 },
                            height: 'auto',
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                    >
                        <img
                            src={slide.image.src}
                            alt={slide.image.alt}
                            style={{
                                width: '100%',
                                height: 'auto',
                                objectFit: 'contain',
                            }}
                        />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Banner;
